import { getPageUrl } from "utils/getPageUrl";
import { trackUAEvent, trackCustomEvent } from "utils/tracking";
import type { LanguageCode } from "config/languages";
import type { StickyBottomBarProps } from "../StickyBottomBar.d";

const BOTTOM_BAR_AIRHELP_PLUS_EVENT_UA = ["clicked", "BottomBar", "AirhelpPlus"] as const;
const BOTTOM_BAR_CHECK_COMPENSATION_EVENT_UA = ["clicked", "BottomBar", "CheckYourCompensation"] as const;
const BOTTOM_BAR_AIRHELP_PLUS_BUY_ESSENTIAL_EVENT_UA = ["clicked", "BottomBar", "AHPBuyEssential"] as const;
const BOTTOM_BAR_AIRHELP_PLUS_BUY_COMPLETE_EVENT_UA = ["clicked", "BottomBar", "AHPBuyComplete"] as const;

const BOTTOM_BAR_AIRHELP_PLUS_EVENT = {
  event: "cta_click",
  label: "airhelp_plus",
  placement: "sticky_bottom_bar",
} as const;

const BOTTOM_BAR_CHECK_COMPENSATION_EVENT = {
  event: "check_compensation",
  label: "check_your_compensation",
  placement: "sticky_bottom_bar",
} as const;

const BOTTOM_BAR_AIRHELP_PLUS_BUY_ESSENTIAL_EVENT = {
  event: "cta_click",
  label: "ahp_buy_essential",
  placement: "sticky_bottom_bar",
} as const;

const BOTTOM_BAR_AIRHELP_PLUS_BUY_COMPLETE_EVENT = {
  event: "cta_click",
  label: "ahp_buy_complete",
  placement: "sticky_bottom_bar",
} as const;

export const getCTAElementProps = (language: LanguageCode, variant: StickyBottomBarProps["variant"]) => {
  switch (variant) {
    case "basic": {
      return {
        href: getPageUrl(language, "webappNewClaim"),
        target: "_blank",
        onClick: () => {
          trackUAEvent(BOTTOM_BAR_CHECK_COMPENSATION_EVENT_UA);
          trackCustomEvent(BOTTOM_BAR_CHECK_COMPENSATION_EVENT);
        },
      };
    }
    case "ahPlus": {
      return {
        href: getPageUrl(language, "airhelpPlus"),
        onClick: () => {
          trackUAEvent(BOTTOM_BAR_AIRHELP_PLUS_EVENT_UA);
          trackCustomEvent(BOTTOM_BAR_AIRHELP_PLUS_EVENT);
        },
      };
    }
    case "ahpBuyComplete": {
      return {
        href: getPageUrl(language, "ahpBuyComplete"),
        onClick: () => {
          trackUAEvent(BOTTOM_BAR_AIRHELP_PLUS_BUY_COMPLETE_EVENT_UA);
          trackCustomEvent(BOTTOM_BAR_AIRHELP_PLUS_BUY_COMPLETE_EVENT);
        },
      };
    }
    case "ahpBuyEssential": {
      return {
        href: getPageUrl(language, "ahpBuyEssential"),
        onClick: () => {
          trackUAEvent(BOTTOM_BAR_AIRHELP_PLUS_BUY_ESSENTIAL_EVENT_UA);
          trackCustomEvent(BOTTOM_BAR_AIRHELP_PLUS_BUY_ESSENTIAL_EVENT);
        },
      };
    }
    default: {
      return {
        href: getPageUrl(language, "webappNewClaim"),
        target: "_blank",
        onClick: () => {
          trackUAEvent(BOTTOM_BAR_CHECK_COMPENSATION_EVENT_UA);
          trackCustomEvent(BOTTOM_BAR_CHECK_COMPENSATION_EVENT);
        },
      };
    }
  }
};
